import React from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { createTheme, mergeStyles, ThemeProvider } from "@fluentui/react";
import reportWebVitals from "./reportWebVitals";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/utilities/authConfig";

import StoreContext from "@/contexts/storeContext";
import store from "@/store";
import { UNIFIED_FONT_FAMILY } from "@/themes/fluentThemes";
import { BrandVariants, createDarkTheme, createLightTheme, Theme } from "@fluentui/react-components";
import { I18nextProvider } from "react-i18next";

import i18n from "./i18n";
export interface ContentProps {
  lightTheme: Theme;
  darkTheme?: Theme;
}
const myNewTheme: BrandVariants = {
  10: "#020305",
  20: "#111723",
  30: "#16263D",
  40: "#193253",
  50: "#1B3F6A",
  60: "#1B4C82",
  70: "#0F6CBD",
  80: "#0078D4",
  90: "#3174C2",
  100: "#4F82C8",
  110: "#6790CF",
  120: "#7D9ED5",
  130: "#92ACDC",
  140: "#A6BAE2",
  150: "#BAC9E9",
  160: "#CDD8EF"
};

export const lightTheme: Theme = {
  ...createLightTheme(myNewTheme),
};

export const darkTheme: Theme = {
  ...createDarkTheme(myNewTheme),
};
export const msalInstance = new PublicClientApplication(msalConfig);
const msalInit = async () => {
  await msalInstance.initialize();
};

// Inject some global styles
mergeStyles({
  ":global(body,html,#root)": {
    margin: 0,
    padding: 0,
    height: "100vh",
    background: "#f4f4f4",
    overflow: "hidden",
    fontFamily: UNIFIED_FONT_FAMILY
  },
});

initializeIcons();
msalInit();

// Fluent UI v8 主题（用于旧版组件）
const theme = createTheme({
  defaultFontStyle: { fontFamily: UNIFIED_FONT_FAMILY },
});
const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

// eslint-disable-next-line no-restricted-globals
root.render(
<StoreContext.Provider value={store}>
  <I18nextProvider i18n={i18n}>
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </ThemeProvider>
  </I18nextProvider>
</StoreContext.Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
